'use client';

import { JSX, useState } from 'react';

import { tw } from '../../utils';

interface CollapsibleSectionProps {
  children: React.ReactNode;
  collapsed?: boolean;
  header?: string | JSX.Element;
  className?: string;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  children,
  collapsed,
  className,
  header,
}: CollapsibleSectionProps) => {
  const [expanded, setExpanded] = useState(!collapsed);

  return (
    <div className={tw(className, 'flex w-full flex-col items-center gap-4')}>
      <div className='flex w-full items-center justify-between gap-4'>
        <div className='flex'>{header}</div>
        <button onClickCapture={() => setExpanded((val) => !val)}>
          <svg
            className={tw(
              'mt-1 h-2 w-4 transition',
              expanded ? 'rotate-180' : '',
            )}
            viewBox='0 0 11 6'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M0.999986 5L4.66896 1.32673C5.10409 0.891091 5.80957 0.89109 6.2447 1.32673L9.9137 5'
              stroke='white'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </button>
      </div>
      <div className={`flex w-full ${expanded ? 'block' : 'hidden'}`}>
        {children}
      </div>
    </div>
  );
};
